// extracted by mini-css-extract-plugin
export var colorBlack = "#000";
export var colorGray = "gray";
export var colorDarkGray = "#262626";
export var colorLightGray = "#e5e5e5";
export var colorWhite = "#fff";
export var colorElectricBlue = "#0000fe";
export var colorPastelBlue = "#bbe5fe";
export var colorCandyPink = "#f9709a";
export var colorPastelPink = "#ffcdd2";
export var colorDefaultLime = "#cef564";
export var colorPastelLime = "#eeffbe";
export var colorBlueLagoon = "#9cf0e1";
export var colorPastelLagoon = "#ceffec";
export var colorDefaultLavender = "#8738f6";
export var colorPastelLavender = "#eadcff";
export var colorBrightYellow = "#ffe500";
export var colorDefaultGreen = "#12b968";
export var breakpointMedium = "768px";
export var breakpointDesktop = "1024px";
export var breakpointLarge = "1440px";
export var colCount = "6";
export var colWidth = "16.6666666667%";
export var popup = "ProgressPopup-module--popup--1GXY6";
export var inner = "ProgressPopup-module--inner--Fo0Cy";
export var popupTitle = "ProgressPopup-module--popupTitle--1rhQ6";
export var sectionTitle = "ProgressPopup-module--sectionTitle--13taY";
export var popupSections = "ProgressPopup-module--popupSections--221uP";
export var popupSection = "ProgressPopup-module--popupSection--1nw_H";
export var count = "ProgressPopup-module--count--eLvBA";
export var number = "ProgressPopup-module--number--2Icp6";